import { AnchorButton } from "../ui/Button.js";

export function CtaBand({
  title,
  body,
  primaryHref,
  primaryLabel,
  secondaryHref,
  secondaryLabel,
}: {
  title: string;
  body: string;
  primaryHref: string;
  primaryLabel: string;
  secondaryHref?: string;
  secondaryLabel?: string;
}) {
  return (
    <div className="rounded-3xl border border-line bg-white p-8 text-center shadow-sm sm:p-12">
      <h2 className="text-2xl font-semibold text-ink sm:text-3xl">{title}</h2>
      <p className="mx-auto mt-3 max-w-[65ch] text-base leading-7 text-muted">{body}</p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <AnchorButton href={primaryHref}>{primaryLabel}</AnchorButton>
        {secondaryHref && secondaryLabel ? (
          <AnchorButton href={secondaryHref} variant="secondary">
            {secondaryLabel}
          </AnchorButton>
        ) : null}
      </div>
    </div>
  );
}
